// removed by extract-text-webpack-plugin
module.exports = {"header":"_8lkzITUtvGUk1UMgAd_in","title-label":"_1ECiRxwDgZcLqsgW3lGdQu","titleLabel":"_1ECiRxwDgZcLqsgW3lGdQu","close":"_3zeu9VIzXNYaWcwp-cE7JW","red":"_29BDOr8rvDgwsyBRYCGk2Q","blue":"_31bNZpmsGGHfQlDOuvt9IC","green":"_314lfmiJlLrXQEFkfJyOAp","lightGreen":"_18aNypDWe1-HwCdtac-3K9"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/src/MessageBox/HeaderLayout.scss
// module id = ./node_modules/wix-style-react/src/MessageBox/HeaderLayout.scss
// module chunks = 0